export default "__VITE_ASSET__C981xt92__"